module.exports = __webpack_public_path__ + "assets/green-fast.16f71f84.svg";